import { useParams } from 'react-router-dom';
import QRReaderForm from './QRReaderForm';
import React from 'react';

export default function EditQRReader() {
  let { id } = useParams();
  return <QRReaderForm id={id} />;
}
